export const GIT_REVISION = '0558ad898fdfc3e56e9614a8b1d7a0aff447c6f9';
export const GIT_COMMIT_AUTHOR = 'Jan Peter Koenig';
